import { connect } from 'react-redux'
import { IStateProps, IDispatchProps } from './YumManualEntryForm'
import {
  addCustomEntry,
  setManualEntryPointsLogicId,
  setManualEntryProgressType,
} from '../../views/Progress/store/ProgressActions'
import YumManualEntryForm from './YumManualEntryForm'
import { IGlobalState } from '../../Root/store/appReducer'
import { GoalWithProgress } from '../../services/api.types'
import {
  getAllDailyProgressSelector,
  getCustomProgressRawSelector,
  getCustomProgressSelector,
  getManualEntryPointsLogicIdSelector,
  getManualEntryProgressTypeSelector,
} from '../../views/Progress/store/progressSelectors'
import { PointsLogicId } from '../../views/ChallengeAdmin/components/ChallengePoints/ChallengePoints'

export interface IOwnProps {
  goal: GoalWithProgress
  onSubmit(): void
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goal, onSubmit } = ownProps
  return {
    goal,
    onSubmit,
    dailyDiary: getAllDailyProgressSelector(state),
    // @ts-ignore
    customProgress: getCustomProgressRawSelector(state, goal.id),
    manualEntryProgressType: getManualEntryProgressTypeSelector(state),
    manualEntryPointsLogicId: getManualEntryPointsLogicIdSelector(state),
  }
}

const mapDispatchToProps: IDispatchProps = {
  addCustomEntry,
  setManualEntryProgressType,
  setManualEntryPointsLogicId,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumManualEntryForm)
